/* L6 Produktbeschreibung (15.10.2026): Tabellen im Abschnitt „Beschreibung“ (und in Abschnitten .gw-pdp-sec--rte) in einen scrollbaren Rahmen legen
   (role=region, Name aus <caption>, per Tastatur erreichbar nur wenn er wirklich scrollt) und Listen ohne
   Standardmarker für Safari/VoiceOver als Liste kennzeichnen. Ändert keine Inhalte, nur die Hülle. */
(function () {
  /* Beschreibung und Abschnitte im GW-Design (.gw-pdp-sec--rte: Anwendung aus custom.anwendung_neu, Ursachen aus custom.ursachen_neu) */
  var roots = document.querySelectorAll('.gw-pdp-sec--beschreibung .gw-pdp-body, .gw-pdp-sec--beschreibung .gw-pdp-body > .gw-pdp-rest, .gw-pdp-sec--rte .gw-pdp-body, .gw-pdp-sec--rte .gw-pdp-body > .gw-pdp-rest');
  if (!roots.length) return;
  var wraps = [];
  var n = 0;
  Array.prototype.forEach.call(roots, function (root) {
    Array.prototype.forEach.call(root.children, function (el) {
      if (el.hasAttribute('class')) return;
      var tag = el.tagName;
      if (tag === 'UL' || tag === 'OL') {
        if (!el.hasAttribute('role')) el.setAttribute('role', 'list');
        /* Listen unter „Sicherheitshinweise“/„Gefahr…“ bekommen schlichte Punkte statt Häkchen */
        var h = el.previousElementSibling;
        while (h && !/^H[23]$/.test(h.tagName)) h = h.previousElementSibling;
        if (tag === 'UL' && h && /sicherheit|gefahr|warn/i.test(h.textContent)) el.setAttribute('data-gwr-plain', '');
        /* <strong> ganz am Anfang eines Schritts wird zum Schritt-Titel (nur wenn kein Text davor steht) */
        if (tag === 'OL') Array.prototype.forEach.call(el.children, function (li) {
          var f = li.firstChild;
          while (f && f.nodeType === 3 && !f.nodeValue.trim()) f = f.nextSibling;
          if (f && f.nodeType === 1 && f.tagName === 'STRONG') f.setAttribute('data-gwr-titel', '');
        });
        return;
      }
      if (tag !== 'TABLE') return;
      var w = document.createElement('div');
      w.className = 'gw-rte-tbl';
      w.setAttribute('role', 'region');
      var cap = el.caption && el.caption.textContent.replace(/\s+/g, ' ').trim();
      if (cap) {
        if (!el.caption.id) el.caption.id = 'gw-rte-cap-' + (++n);
        w.setAttribute('aria-labelledby', el.caption.id);
      } else {
        w.setAttribute('aria-label', 'Tabelle');
      }
      el.parentNode.insertBefore(w, el);
      w.appendChild(el);
      wraps.push(w);
    });
  });
  if (!wraps.length) return;
  var check = function () {
    wraps.forEach(function (w) {
      if (w.scrollWidth > w.clientWidth + 1) w.setAttribute('tabindex', '0');
      else w.removeAttribute('tabindex');
    });
  };
  check();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(check, 150); });
  /* „Mehr anzeigen“ öffnet versteckte Tabellen: dann neu messen */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-gw-pdp-more]')) setTimeout(check, 50);
  });
  document.addEventListener('beforematch', function () { setTimeout(check, 50); }, true);
})();
